import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLang } from './LangContext';
import LanguageSwitcher from './components/LanguageSwitcher';

function TermsOfService() {
  const { t } = useTranslation();
  const { prefix } = useLang();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background text-on-background">
      <header className="fixed top-0 z-50 h-20 w-full border-b border-white/10 bg-zinc-950/80 backdrop-blur-md">
        <div className="mx-auto flex h-full max-w-7xl items-center justify-between px-6 md:px-8">
          <Link to={prefix + '/'} className="flex items-center gap-3" aria-label="ElmakinaTech">
            <img src="/elmakinatech-icon.svg" alt="" className="h-10 w-auto" />
            <span className="text-xl font-bold tracking-tighter text-white">ElmakinaTech</span>
          </Link>
          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <Link to={prefix + '/'} className="rounded bg-secondary-container px-5 py-3 font-label-caps text-label-caps text-on-secondary-fixed transition-all duration-300 hover:brightness-110">
              {t('legal.nav')}
            </Link>
          </div>
        </div>
      </header>

      <main className="pt-20">
        <article className="mx-auto max-w-3xl px-6 py-16 md:px-8 md:py-24">
          <span className="mb-4 block font-label-caps text-label-caps text-cyan-400">{t('legal.updated')}: 15/06/2026</span>
          <h1 className="hero-title text-4xl sm:text-5xl text-white mb-8">{t('legal.terms.title')}</h1>

          <p className="text-zinc-300 leading-relaxed mb-10">{t('legal.terms.intro')}</p>

          <section className="mb-10">
            <h2 className="text-xl font-bold text-white mb-4">{t('legal.terms.service.title')}</h2>
            <p className="text-zinc-300 leading-relaxed">{t('legal.terms.service.body')}</p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-bold text-white mb-4">{t('legal.terms.use.title')}</h2>
            <p className="text-zinc-300 leading-relaxed mb-4">{t('legal.terms.use.body')}</p>
            <ul className="list-disc pl-5 space-y-2 text-zinc-300">
              {t('legal.terms.use.items', { returnObjects: true }).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-bold text-white mb-4">{t('legal.terms.propiedad.title')}</h2>
            <p className="text-zinc-300 leading-relaxed">{t('legal.terms.propiedad.body')}</p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-bold text-white mb-4">{t('legal.terms.responsabilidad.title')}</h2>
            <p className="text-zinc-300 leading-relaxed">{t('legal.terms.responsabilidad.body')}</p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-bold text-white mb-4">{t('legal.terms.termination.title')}</h2>
            <p className="text-zinc-300 leading-relaxed">{t('legal.terms.termination.body')}</p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-bold text-white mb-4">{t('legal.terms.law.title')}</h2>
            <p className="text-zinc-300 leading-relaxed">{t('legal.terms.law.body')}</p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-bold text-white mb-4">{t('legal.terms.contact.title')}</h2>
            <p className="text-zinc-300 leading-relaxed">{t('legal.terms.contact.body')}</p>
          </section>
        </article>
      </main>

      <footer className="bg-zinc-950 w-full py-12 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <Link to={prefix + '/'} className="flex items-center gap-3">
            <img src="/elmakinatech-icon.svg" alt="" className="h-8 w-auto" />
            <span className="text-lg font-black text-white tracking-tighter">ElmakinaTech</span>
          </Link>
          <div className="flex gap-6">
            <Link className="text-zinc-500 font-label-caps text-xs uppercase tracking-widest hover:text-cyan-400 transition-all" to={prefix + '/privacidad'}>{t('home.footer.privacy')}</Link>
            <Link className="text-zinc-500 font-label-caps text-xs uppercase tracking-widest hover:text-cyan-400 transition-all" to={prefix + '/terminos'}>{t('legal.terms.title')}</Link>
            <Link className="text-zinc-500 font-label-caps text-xs uppercase tracking-widest hover:text-cyan-400 transition-all" to={prefix + '/politica-de-cookies'}>{t('legal.cookies.title')}</Link>
            <Link className="text-zinc-500 font-label-caps text-xs uppercase tracking-widest hover:text-cyan-400 transition-all" to={prefix + '/contacto'}>{t('contact.title')}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default TermsOfService;
